import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {HttpClient} from '@angular/common/http';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';
import {first, take} from 'rxjs/operators';
import {Uuid} from '../interface/response/uuid';
import {CommissionImport} from '../interface/commission-import';

@Injectable({
  providedIn: 'root'
})
export class CommissionImportService {
  public readonly importListSubject: ReplaySubject<CountedAndPaginated<CommissionImport>>
    = new ReplaySubject<CountedAndPaginated<CommissionImport>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadImportList(page: number, pageSize: number, filters: object, subject?: Subject<CountedAndPaginated<CommissionImport>>): void {
    this.httpClient.get(`/rest/crm/commission-import?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<CommissionImport>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.importListSubject.next(result);
        }
      });
  }

  public downloadImportsReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/commission-import/method/report?`
      + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public downloadImportFile(importId: string): void {
    this.document.location.href = `/rest/crm/commission-import/${importId}/downloadFile`;
  }

  public import(formData: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/commission-import`, formData)
      .pipe(
        take(1)
      ) as Observable<Uuid>;
  }

  public deleteImport(uuid: string): Observable<Uuid>  {
    return this.httpClient.delete(`/rest/crm/commission-import/${uuid}`)
      .pipe(first()) as Observable<Uuid>;
  }

  public restartImport(uuid: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/commission-import/${uuid}/restart`, {})
      .pipe(first());
  }

  public downloadErrorsReport(uuid: string): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/commission-import/${uuid}/errors-report`, {})
      .pipe(first()) as Observable<Uuid>;
  }
}
